import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const TestModeContext = createContext(false);

export const useTestMode = () => useContext(TestModeContext);

export const TestEnvBanner = () => (
  <div
    className="fixed top-0 left-0 right-0 h-7 z-[60] bg-amber-400 text-black flex items-center justify-center text-[11px] font-semibold uppercase tracking-wider select-none"
    data-testid="test-env-banner"
  >
    TEST ENVIRONMENT — data here is not real
  </div>
);

export const TestModeProvider = ({ children }) => {
  const [testMode, setTestMode] = useState(false);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/app-mode`)
      .then((res) => {
        if (active) setTestMode(res.data?.test_mode === true);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <TestModeContext.Provider value={testMode}>
      {testMode && <TestEnvBanner />}
      <div className={testMode ? "pt-7" : ""}>{children}</div>
    </TestModeContext.Provider>
  );
};
